import html2canvas from "html2canvas";
import React from "react";
import styled from "styled-components";
import Swal from "sweetalert2";

const ImageSaveButton = () => {
  const onCapture = () => {
    html2canvas(
      document.querySelector("#digimon-container") as HTMLDivElement
    ).then((canvas) => {
      onSaveAs(canvas.toDataURL("image/png"), "image-download.png");
    });
  };

  const onSaveAs = (url: string, filename: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);

    link.click();
    Swal.fire("결과가 이미지로 저장되었습니다.");
    document.body.removeChild(link);
  };

  return (
    <Button type="button" onClick={() => onCapture()}>
      결과 이미지로 저장
    </Button>
  );
};

export default ImageSaveButton;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;

  border-radius: 10px;

  font-size: 18px;
`;
